import React from "react";

interface VideoTimerProps {
  videoLimit: number;
  videoCoundown: number;
}

export const VideoTimer: React.FC<VideoTimerProps> = (props) => {
  return (
    <div className="lander-cpl-quiz-timer--container">
      <div className="lander-cpl-quiz-timer--description">
        {`Please watch ${props.videoLimit} seconds of the video before answering.`}
      </div>
      <div className="lander-cpl-quiz-timer--countdown">{`:${props.videoCoundown}`}</div>
    </div>
  );
};
